(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this.storageKey = `announcement-ticker:${this.dataset.sectionId}`;
      this.setUpDismiss();
      this.setUpRotation();
    }

    disconnectedCallback() {
      this.stopRotation();
    }

    setUpDismiss() {
      const closeButton = this.querySelector('.announcement-ticker__close');
      if (!closeButton) return;

      // The theme editor always shows the bar so the merchant can keep editing it.
      if (!this.dataset.designMode && this.readStorage() === 'closed') {
        this.hidden = true;
        return;
      }

      closeButton.addEventListener('click', () => {
        this.hidden = true;
        this.stopRotation();
        this.writeStorage('closed');
      });
    }

    setUpRotation() {
      this.items = Array.from(this.querySelectorAll('.announcement-ticker__rotator-item'));
      if (this.items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.interval = (parseFloat(this.dataset.rotateInterval) || 4) * 1000;
      this.index = 0;
      this.startRotation();

      if (this.dataset.pauseOnHover) {
        this.addEventListener('mouseenter', this.stopRotation.bind(this));
        this.addEventListener('mouseleave', this.startRotation.bind(this));
      }
    }

    startRotation() {
      if (this.timer || !this.items) return;
      this.timer = setInterval(this.showNext.bind(this), this.interval);
    }

    stopRotation() {
      clearInterval(this.timer);
      this.timer = null;
    }

    showNext() {
      const current = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      const next = this.items[this.index];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');

      clearTimeout(this.leaveTimer);
      this.leaveTimer = setTimeout(() => current.classList.remove('is-leaving'), 500);
    }

    readStorage() {
      try {
        return sessionStorage.getItem(this.storageKey);
      } catch (error) {
        return null;
      }
    }

    writeStorage(value) {
      try {
        sessionStorage.setItem(this.storageKey, value);
      } catch (error) {
        // Private browsing or a full quota — the bar simply comes back next load.
      }
    }
  }

  customElements.define('announcement-ticker', AnnouncementTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Keep --header-height in sync while the logo shrinks on scroll (reduce-logo-size),
      // so sticky elements pinned below the header (e.g. the announcement bar) track its height.
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight.bind(this));
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
